/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Error_ConnectionInputs */



/**
* | output |
* | --- |
* | "Voice connection lost. Please restart voice mode." |
*
* @param {Voice_Error_ConnectionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const voice_error_connection = /** @type {((inputs?: Voice_Error_ConnectionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Error_ConnectionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprachverbindung unterbrochen. Bitte starten Sie den Sprachmodus erneut.")
	return /** @type {LocalizedString} */ ("Voice connection lost. Please restart voice mode.")
});